// Helpers centrais para planos de assinatura
import axios from "axios";

const API = `${window.location.origin}/api`;

// Cache em memória — invalidado no login/logout
let _planoCache = null;
let _loadPromise = null;

export const PLANO_LABELS = {
  start: "Start",
  pro: "Pro",
  premium: "Premium",
  corporativo: "Corporativo",
};

export const PLANO_CORES = {
  start: { bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-300" },
  pro: { bg: "bg-blue-100", text: "text-blue-700", border: "border-blue-300" },
  premium: { bg: "bg-amber-100", text: "text-amber-700", border: "border-amber-300" },
  corporativo: { bg: "bg-purple-100", text: "text-purple-700", border: "border-purple-300" },
};

export async function carregarPlanoAtual(force = false) {
  if (_planoCache && !force) return _planoCache;
  if (_loadPromise) return _loadPromise;
  _loadPromise = axios
    .get(`${API}/planos/meu`)
    .then((r) => {
      _planoCache = r.data;
      _loadPromise = null;
      return _planoCache;
    })
    .catch((e) => {
      _loadPromise = null;
      throw e;
    });
  return _loadPromise;
}

export function invalidarCachePlano() {
  _planoCache = null;
  _loadPromise = null;
}

export function getPlanoCacheSync() {
  return _planoCache;
}

export function temFeatureSync(feature) {
  if (!_planoCache) return true; // fail-open enquanto não carrega (UX)
  if (_planoCache.super_admin) return true;
  return !!(_planoCache.plano?.features?.[feature]);
}

// Event-bus simples para o modal global de upgrade
const _listeners = new Set();
export function abrirUpgradeModal(payload) {
  _listeners.forEach((l) => {
    try { l(payload); } catch (_) { /* noop */ }
  });
}
export function onUpgradeModal(cb) {
  _listeners.add(cb);
  return () => _listeners.delete(cb);
}
